import en from './en';
import es from './es';
import fr from './fr';
import de from './de';
import ru from './ru';

const translations = {
  en,
  es,
  fr,
  de,
  ru,
};

export function t(key, language = 'en') {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      // Fallback to English if translation not found
      value = undefined;
      break;
    }
  }
  
  // If not found in current language, try English
  if (value === undefined) {
    value = translations['en'];
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        value = key; // Return the key itself as last resort
        break;
      }
    }
  }
  
  return value || key;
}

export default translations;
